import { render, staticRenderFns } from "./uploadAdmissionPhotos.vue?vue&type=template&id=310fe1d9&scoped=true"
import script from "./uploadAdmissionPhotos.vue?vue&type=script&lang=js"
export * from "./uploadAdmissionPhotos.vue?vue&type=script&lang=js"
import style0 from "./uploadAdmissionPhotos.vue?vue&type=style&index=0&id=310fe1d9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310fe1d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310fe1d9')) {
      api.createRecord('310fe1d9', component.options)
    } else {
      api.reload('310fe1d9', component.options)
    }
    module.hot.accept("./uploadAdmissionPhotos.vue?vue&type=template&id=310fe1d9&scoped=true", function () {
      api.rerender('310fe1d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/uploadAdmissionPhotos.vue"
export default component.exports